import pageLoader from "./common-components/pageLoader";
import selectTo from './common-components/selectTo';
import landscapeOff from "./common-components/landscapeOff";
import mobileMenu from './common-components/mobile-menu';
import IntelInput from './components/intel-input';
import StickyHeader from './components/sticky-header';
import Carousel from './components/carousel';
import Tab from './components/tab';
import HorizontalImageSection from './components/horizontal-image-section';
import FeatureProjects from './components/feature-projects';
import HeroBanner from './components/hero-banner';
import VideoLoader from "./common-components/video-loader";

// Animations
import animateObserver from "./common-components/animateObserver";
import ZoomCircleAnimation from './components/zoom-circle-animation';
import RevealImageAnimation from './components/reveal-image-animation';


// Init Animation observer
animateObserver();
// Init Landscape off
landscapeOff();
// Init Mobile menu
mobileMenu();
// Init Sticky Header
StickyHeader();
// Init Contact form
IntelInput();
// Init hero carousel
Carousel('.heroSlider', {
    spaceBetween: 0,
    effect: "fade",
    autoplay: {
        delay: 5000,
        disableOnInteraction: false,
    },
    speed: 1000,
    pagination: {
        el: ".hero-pagination",
        clickable: true,
    },
});
// Init news carousel
Carousel('.newsSlider', {
    slidesPerView: 1,
    spaceBetween: 0,
    speed: 1000,
    pagination: {
        el: ".news-pagination",
        clickable: true,
    },
    navigation: {
        nextEl: ".news-button-next",
        prevEl: ".news-button-prev",
    },
    breakpoints: {
        640: {
            slidesPerView: 1,
            spaceBetween: 0,
        },
        768: {
            slidesPerView: 1.8,
            spaceBetween: 15,
        },
        1024: {
            slidesPerView: "auto",
            spaceBetween: 30,
        },
    },
});
// Init Tab
Tab();
// Init Horizontal Image Section
HorizontalImageSection();
// Init feature projects
FeatureProjects();
// Init Hero Banner
HeroBanner();
// Zoom Circle animation init
ZoomCircleAnimation();
// Init Reveal Image animation
RevealImageAnimation();
// Init video loader
VideoLoader();
